import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { TabType } from ".";

const TabNavigation = ({ activeTab, onTabChange }: { activeTab: TabType; onTabChange: (tab: TabType) => void }) => {
  const { t } = useTranslation("plans", { keyPrefix: "page.plansOverviewPage" });

  return (
    <Box sx={styles.tabContainer}>
      <Chip
        label={t("transactions")}
        variant="outlined"
        sx={styles.tabChip(activeTab === "transactions", true)}
        onClick={() => onTabChange("transactions")}
      />
      <Chip
        label={t("invoices")}
        variant="outlined"
        sx={styles.tabChip(activeTab === "invoices", false)}
        onClick={() => onTabChange("invoices")}
      />
    </Box>
  );
};

export default TabNavigation;

const styles = {
  tabContainer: {
    display: "flex",
    border: "1px solid #D0D5DD",
    height: "fit-content",
    width: "fit-content",
    borderRadius: "8px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    overflow: "hidden",
  },
  tabChip: (isCurrent: boolean, hasBorderRight: boolean) => ({
    fontFamily: "Montserrat",
    border: "none",
    borderRadius: "0",
    padding: "10px 16px",
    color: isCurrent ? "var(--Gray-800, #1D2939)" : "var(--Gray-700, #344054)",
    backgroundColor: isCurrent ? "var(--Gray-50, #F9FAFB)" : "var(--Base-White, #FFF)",
    borderRight: hasBorderRight ? "1px solid #D0D5DD" : "",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    "& .MuiChip-label": {
      padding: 0,
    },
  }),
};
